<template>
  <div class="collection-container">
    <header class="page-header">
      <h2 class="page-title">我的收藏</h2>
      <p class="collection-stats">共收藏 {{ collectedArticles.length }} 篇文章</p>
    </header>

    <!-- 收藏列表 -->
    <div v-if="collectedArticles.length > 0" class="collection-list">
      <div 
        v-for="article in collectedArticles" 
        :key="article.id"
        class="collection-item"
      >
        <!-- 文章信息 -->
        <div class="article-info" @click="viewArticle(article.id)">
          <h3>{{ article.title }}</h3>
          <p>{{ article.summary }}</p>
          <div class="article-meta">
            <span><i class="bi bi-eye"></i> {{ article.views }}</span>
            <span><i class="bi bi-heart"></i> {{ article.likes }}</span>
            <span><i class="bi bi-calendar"></i> {{ formatDate(article.publishTime) }}</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="item-actions">
          <button @click="removeFromCollection(article.id)" class="btn-remove">
            <i class="bi bi-trash"></i>
            取消收藏
          </button>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-else class="empty-state">
      <i class="bi bi-bookmark-heart fs-1 text-muted"></i>
      <h3>暂无收藏</h3>
      <p>快去收藏感兴趣的面经吧！</p>
      <router-link to="/article" class="browse-btn">
        浏览面经
      </router-link>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'MyCollection',
  computed: {
    collectedArticles() {
      // 从所有文章中筛选已收藏的文章
      const allArticles = [
        // 这里引入所有文章数据
        // 实际项目中应该从API获取
        ...this.$parent.$children.find(c => c.$options.name === 'ArticleData')?.articles || []
      ]
      
      return allArticles.filter(article => 
        store.isCollected(article.id)
      )
    }
  },
  methods: {
    removeFromCollection(articleId) {
      store.toggleCollect(articleId)
      this.$toast.success('已取消收藏')
    },
    viewArticle(articleId) {
      this.$router.push({
        name: 'articleDetail',
        params: { id: articleId }
      })
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('zh-CN')
    }
  }
}
</script>

<style scoped>
.collection-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.page-header {
  text-align: center;
  margin-bottom: 30px;
}

.collection-stats {
  color: #666;
  font-size: 16px;
}

.collection-item {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.collection-item:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.article-info {
  cursor: pointer;
}

.article-info h3 {
  color: #1a1a1a;
  font-size: 18px;
  margin-bottom: 10px;
}

.article-info p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.article-meta {
  display: flex;
  gap: 15px;
  font-size: 13px;
  color: #999;
}

.item-actions {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.btn-remove {
  background: #ff4757;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-remove:hover {
  background: #ff3838;
  transform: translateY(-1px);
}

.browse-btn {
  display: inline-block;
  margin-top: 15px;
  padding: 12px 30px;
  background: #1890ff;
  color: white;
  text-decoration: none;
  border-radius: 25px;
  transition: all 0.3s ease;
}

.browse-btn:hover {
  background: #40a9ff;
  transform: translateY(-1px);
}
</style>